<!-- eslint-disable -->

<template>
  <div class="flex space-x-2 items-center">
    <div class="spinner-border" role="status" style="height: 20px;width: 20px;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
}
</script>

<style lang="scss" scoped></style>
